import React from "react"
import { useMemo } from "react"
import GroupsPagedTable from "./groups_paged_table"

export default function ProfileGroupsTabs({ children, groupsProps }) {
  const { profileId, policy } = groupsProps

  const enabled = useMemo(() => {
    return (profileId ?? false) || false
  }, [profileId, policy])

  if (!enabled) {
    return <div className="well">{children}</div>
  }

  return (
    <>
      <div role="tabpanel">
        <ul className="nav nav-tabs" role="tablist">
          <li role="presentation" className="active">
            <a
              href="#profile"
              id="Profile-tab-button"
              aria-controls="Profile"
              role="tab"
              data-toggle="tab"
            >
              Profile
            </a>
          </li>
          <li role="presentation">
            <a
              href="#groups"
              id="groups-tab-button"
              aria-controls="groups"
              role="tab"
              data-toggle="tab"
            >
              Groups
            </a>
          </li>
        </ul>
      </div>

      <div className="tab-content">
        <div role="tabpanel" className="tab-pane active" id="profile">
          {children}
        </div>
        <div role="tabpanel" className="tab-pane" id="groups">
          <GroupsPagedTable {...groupsProps} />
        </div>
      </div>
    </>
  )
}
